<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
      fill-height>
      <v-flex xs12 md12 lg7>
        <v-dialog v-model='waitForDistinctive' persistent max-width='300'>
          <v-card>
            <v-card-title class='headline'>
              Sending Trip Data to Distinctive
            </v-card-title>
            <v-card-text>
              <v-layout>
                <v-flex xs12>
                  <p> This may take a few moments .. </p>
                </v-flex>
                <v-flex xs4></v-flex>
                <v-flex xs4>
                  <v-icon v-if='distinctiveComplete'> mdi-check </v-icon>
                  <v-progress-linear v-else indeterminate />
                </v-flex>
                <v-flex xs4></v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
        <material-card
          color='busie'
          dark
          hover
          :title='quote.trip.trip_id'
          text='Make edits to a trip and save'>
          <v-tooltip
            v-for='icon in icons'
            v-if='icon.show'
            :key='icon.name'
            content-class='bottom'
            bottom>
            <template #activator=' { on } '>
              <v-icon
                :color='icon.color'
                v-on='on'>
                {{ icon.icon }}
              </v-icon>
            </template>
            <span>Trip {{ icon.message }}</span>
          </v-tooltip>
          <v-form id='form' ref='form' @submit='submit'>
            <v-container>
              <v-layout row wrap>
                <v-flex
                  v-for='(value, propertyName) in quote.trip.trip_planner'
                  v-if='displayProperty(propertyName)'
                  :key='propertyName'
                  xs12 md4 lg4>
                  <v-text-field
                    :label='fieldLabel(propertyName)'
                    v-model='payload.trip.trip_planner[propertyName]' disabled/>
                </v-flex>
              </v-layout>
              <v-layout v-for='stop in stops' :key='stop.id' row wrap>
                <v-flex
                  v-for='(value, propertyName) in stop'
                  :key='propertyName'
                  v-if='(displayProperty(propertyName) && value != null)'
                  :xs12='propertyName === "location"'
                  :xs6='propertyName != "location"'
                  :md7='propertyName === "location"'
                  :md3='propertyName === "date"'
                  :md2='propertyName === "time"'>
                  <v-tooltip bottom content-class='bottom'>
                    <v-text-field
                      slot='activator'
                      :label='fieldLabel(propertyName)'
                      :value='propertyName === "date" ? date(value).date : value'
                      disabled/>
                    <span>{{ tooltip }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  v-for='(value, propertyName) in quote'
                  v-if='displayProperty(propertyName)'
                  :key='propertyName'
                  xs6 md4 lg4>
                  <v-text-field
                    v-if="propertyName != 'assigned_to'"
                    :label='fieldLabel(propertyName)'
                    v-model='payload[propertyName]'
                    :disabled='disableField(propertyName)'/>
                  <v-select
                    v-else
                    :label="fieldLabel(propertyName)"
                    v-model="payload[propertyName]"
                    :items="formattedUsers"/>
                </v-flex>
                <v-flex xs6 md4 lg4>
                  <v-text-field
                    label='Passengers'
                    type='number'
                    v-model='payload.trip.passengers'/>
                </v-flex>
                <v-flex xs6 md4 lg4>
                  <v-text-field
                    label='Wheelchairs'
                    type='number'
                    v-model='payload.trip.wheelchairs'/>
                </v-flex>
                <v-flex xs6 md4 lg4>
                  <v-select
                    v-model='payload.trip.amenities'
                    :items='formattedAmenities'
                    attach
                    chips
                    label='Amenities'
                    multiple/>
                </v-flex>
                <v-flex xs12>
                  <v-textarea label='Additional Info' v-model='quote.trip.notes'/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <template #actions>
            <v-menu
              offset-y
              content-class='dropdown-menu'
              transition='slide-y-transition'>
              <template #activator=' { on } '>
                <BusieButton color='secondary' v-on='on'>
                    More Actions
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                </BusieButton>
              </template>
              <v-card>
                <v-list dense>
                  <EmailContactDialog v-model='email.template'>
                    <template #activator=' { on } '>
                      <v-list-tile color='secondary' v-on='on'>
                        <v-list-tile-title> Contact </v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <template #actions='{ deactivate }'>
                      <v-btn color='secondary' v-on='deactivate'>
                        Close
                      </v-btn>
                      <v-btn
                        color='primary'
                        v-on='deactivate'
                        @click='send'>
                        Send
                      </v-btn>
                    </template>
                  </EmailContactDialog>
                  <ConfirmationDialog
                    v-for='dialog in dialogs'
                    :key='dialog.name'
                    v-if='dialog.conditional'>
                    <template #activator=' { on } '>
                      <v-list-tile v-on='on' :color='dialog.tileColor'>
                        <v-list-tile-title>
                          {{ dialog.title }}
                        </v-list-tile-title>
                      </v-list-tile>
                    </template>
                    <template #main>
                      <span class='confirmation-message'>
                        {{ dialog.message }}
                      </span>
                    </template>
                    <template #actions=' { deactivate } '>
                      <BusieButton
                        text="I've Changed My Mind"
                        color='secondary'
                        v-on='deactivate'/>
                      <BusieButton
                        text='Confirm'
                        :color='dialog.buttonColor'
                        v-on='deactivate'
                        @click='dialog.clickHandler'/>
                    </template>
                  </ConfirmationDialog>
                </v-list>
              </v-card>
            </v-menu>
            <v-spacer />
            <BusieButton
              text='Go Back'
              color='secondary'
              @click='$router.go(-1)'/>
            <BusieButton
              text='Save Changes'
              color='info'
              @click='$refs.form.$emit("submit")'/>
          </template>
        </material-card>
      </v-flex>
      <v-flex xs12 md12 lg5>
        <material-card dark hover>
          <HereMap
            apikey='1VFL9IqD5ZaU3KUEaaG64C44Znh8EUKtPOyyds09U5c'
            lat='42.3601'
            lng='-71.0589'
            width='100%'
            height='250px'
            @create-here-objects='_setHereProps'/>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HereMap from '@bit/bradyperry.busie.here-map'
import EmailContactDialog from '@/components/busie/EmailContactDialog'
import ConfirmationDialog from '@/components/busie/ConfirmationDialog'
import BusieButton from '@/components/busie/StandardButton'
import { mapActions, mapGetters } from 'vuex'
import ApiFactory from '@/api/ApiFactory'
import label from '@/utils/label';

const TripsApi = ApiFactory.get('trips');

export default {
  components: {
    HereMap,
    EmailContactDialog,
    ConfirmationDialog,
    BusieButton
  },
  created () {
    this.payload = Object.assign({}, this.quote);
    this.payload.trip = Object.assign({}, this.quote.trip);
    this.email.trip = this.quote.trip.id
    TripsApi.get(this.quote.trip.id).then(
      ({ data }) => this._handleRoute(data.route)).catch(
        e => this.raiseError(e))
  },
  data () {
    return {
      payload: {},
      platform: {},
      map: {},
      tooltip: 'Stop changes should be reflected with a new trip',
      email: {
        trip: null,
        template: null
      },
      waitForDistinctive: false,
      distinctiveComplete: false
    }
  },
  computed: {
    id () { return this.$route.params.id },
    quote() { return this.byId(parseInt(this.id)) },
    stops() { return this.stopsByTripMap.get(this.quote.trip.id) },
    formattedAmenities () {
      return this.amenities.map(
        amenity => { return {value: amenity.id, text: amenity.name} } )
    },
    formattedUsers () {
      return this.users.map(user => ({
        value: user.id,
        text: `${user.user.first_name} ${user.user.last_name}`
      }))
    },
    displayProperty: () =>
      prop => ![
        'trip',
        'trip_planner',
        'id',
        'created',
        'distinctive_id',
        'extra_driver',
        'overnight',
        'user',
        'rate_schemas',
        'rate',
        'request_to_book'
      ].includes(prop),
    fieldLabel: () => prop => label(prop),
    disableField: () =>
      prop => ['dead_head_miles', 'live_miles'].includes(prop),
    icons () {
      const { cancelled, complete, booked } = this.quote.trip
      const { extra_driver, overnight, request_to_book } = this.quote
      return [
        {
          name: 'request-to-book',
          show: !!request_to_book,
          icon: 'mdi-flag-checkered',
          color: 'success',
          message: 'Planner is ready to book'
        },
        {
          name: 'cancellation',
          show: !!cancelled,
          color: 'error',
          icon: 'mdi-cancel',
          message: 'has been canceled'
        },
        {
          name: 'complete',
          show: !!complete,
          color: 'success',
          icon: 'mdi-check-all',
          message: 'has been completed'
        },
        {
          name: 'booked',
          show: !!booked,
          color: 'success',
          icon: 'mdi-check',
          message: 'has been booked',
        },
        {
          name: 'extra-driver',
          show: !!extra_driver,
          color: 'warning',
          icon: 'mdi-account-plus',
          message: 'requires an extra driver'
        },
        {
          name: 'overnight',
          show: !!overnight,
          color: 'warning',
          icon: 'mdi-calendar-multiple',
          message: 'has stops on multiple dates'
        }
      ]
    },
    dialogs() {
      const { cancelled, complete, booked } = this.quote.trip
      const hasDistinctive = !!this.distinctive._id
      return [
        {
          name: 'complete',
          conditional: !complete,
          title: 'Mark As Complete',
          tileColor: 'success',
          message: 'Are you sure you want to mark this trip as complete?',
          buttonColor: 'success',
          clickHandler: () => this.completeTrip()
        },
        {
          name: 'cancel',
          conditional: !cancelled,
          title: 'Cancel Trip',
          tileColor: 'error',
          message: 'Are you sure you want to cancel this trip?',
          buttonColor: 'danger',
          clickHandler: () => this.cancelTrip()
        },
        {
          name: 'book',
          conditional: !booked,
          title: 'Book Trip',
          tileColor: 'success',
          message: 'Are you sure you want to mark this trip as booked?',
          buttonColor: 'success',
          clickHandler: () => this.bookTrip()
        },
        {
          name: 'distinctive',
          conditional: !!hasDistinctive,
          title: 'Push To Distinctive',
          tileColor: 'success',
          message: 'Are you sure you want to send to distinctive?',
          buttonColor: 'success',
          clickHandler: () => this.pushToDistinctive()
        }
      ]
    },
    ...mapGetters('quotes', [ 'byId' ]),
    ...mapGetters('stops', [ 'stopsByTripMap' ]),
    ...mapGetters('dates', { date: 'byId' }),
    ...mapGetters('amenities', { amenities: 'all' }),
    ...mapGetters('users', { users: 'all' }),
    ...mapGetters('integrations', [ 'distinctive' ])
  },
  methods: {
    isFirstStop (stop) {
      return stop.id === this.stops[0].id
    },
    submit () {
      delete this.payload.trip.trip_planner.user
      return this.update(this.payload).then(
        () => {
          const message = `Successfully edited trip: ${this.payload.trip.trip_id}`
          const link = `/quotes/${this.payload.id}`
          this.addNotification({ message, link })
        }).catch(e => this.raiseError(e))
    },
    send () {
      return this.createEmail(this.email).then(
        () => {
          const message = `Confirmation email sent for trip: ${this.payload.trip.trip_id}`
          const link = `/quotes/${this.payload.id}`
          this.addNotification({ message, link })
        }).catch(e => this.raiseError(e))
    },
    cancelTrip () {
      this.payload.trip.cancelled = true
      this.submit()
    },
    bookTrip () {
      this.payload.trip.booked = true
      this.submit()
    },
    completeTrip () {
      this.payload.trip.complete = true
      this.submit()
    },
    pushToDistinctive () {
      const pd = this.date(this.stops[0].date)
      const pt = this.stops[0].time
      const ld = this.date(this.stops[this.stops.length - 2].date)
      const lt = this.stops[this.stops.length - 2].time
      const pickupDateTime = new Date(pd.date + 'T' + pt).toISOString()
      const leaveDateTime = new Date(ld.date + 'T' + lt).toISOString()
      const payload = {
        clientSurname: this.payload.trip.trip_planner.name.split(' ')[1],
        clientFirstName: this.payload.trip.trip_planner.name.split(' ')[0],
        clientNumber: this.payload.trip.trip_planner.number,
        clientEmail: this.payload.trip.trip_planner.email,
        movementDescription: this.payload.trip.trip_id,
        pickup: this.stops[0].location,
        singleJourney: this.payload.trip.tripType == 'r' ? false : true,
        destination: this.stops[this.stops.length - 2].location,
        passengers: this.payload.trip.passengers,
        pickupDateTime,
        leaveDateTime
      };
      this.waitForDistinctive = true;
      return this.dumpDistinctiveData(payload).then(() => {
        const message = `Data for trip ${this.payload.trip.trip_id} sent to distinctive`;
        const link = `/quotes/${this.payload.id}`;
        this.addNotification({ message, link });
        this.distinctiveComplete = true
        const vm = this
        setTimeout(() => {
          this.waitForDistinctive = false
          this.distinctiveComplete = false
        }, 1000)
      }).catch((e) => {
        this.waitForDistinctive = false
        this.raiseError(e)
      })
    },
    ...mapActions('quotes', [ 'update' ]),
    ...mapActions('app', [ 'raiseError', 'addNotification' ]),
    ...mapActions('emails', { createEmail: 'create' }),
    ...mapActions('integrations', [ 'dumpDistinctiveData' ]),
    _setHereProps: function (props) {
      this.map = props.map
      this.platform = props.platform
    },
    _handleRoute: function (route) {
      var route = route.response.route[0]
      this._addRouteShapeToMap(route, this.map)
      this._addManeuversToMap(route, this.map)
    },
    _addRouteShapeToMap: function (route, map) {
      var lineString = new H.geo.LineString(),
        routeShape = route.shape,
        polyline
      try {
        routeShape.forEach(function (point) {
          var parts = point.split(',')
          lineString.pushLatLngAlt(parts[0], parts[1])
        })
      } catch (e) {
        if (e.name == 'TypeError') {
          for (var i = 0; i < (routeShape.length / 2); i++) {
            var j = (2 * i)
            lineString.pushLatLngAlt(routeShape[j], routeShape[j + 1])
          }
        }
      }
      polyline = new H.map.Polyline(lineString, {
        style: {
          lineWidth: 4,
          strokeColor: '#ff0018'
        }
      })
      polyline.id = 'route' // used to remove the route later on
      // Add the polyline to the map
      map.addObject(polyline)
      // And zoom to its bounding rectangle
      map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      })
      // map.setViewBounds(polyline.getBounds(), true)
    },
    _addManeuversToMap (route, map) {
      var maneuver
      var svgMarkup = '<svg width="18" height="18" ' +
        'xmlns="http://www.w3.org/2000/svg">' +
        '<circle cx="8" cy="8" r="8" ' +
          'fill="#f7606e" stroke="white" stroke-width="1"  />' +
        '</svg>',
        dotIcon = new H.map.Icon(svgMarkup, { anchor: { x: 8, y: 8 } }),
        group = new H.map.Group(),
        i,
        j
      group.id = 'route' // used to remove the route later on
      // Add a marker for each maneuver
      for (i = 0; i < route.leg.length; i += 1) {
        for (j = 0; j < route.leg[i].maneuver.length; j += 1) {
          // Get the next maneuver.
          maneuver = route.leg[i].maneuver[j]
          // Add a marker to the maneuvers group
          var marker = new H.map.Marker(
            {
              lat: maneuver.position.latitude,
              lng: maneuver.position.longitude
            },
            {
              icon: dotIcon
            }
          )
          marker.instruction = maneuver.instruction
          group.addObject(marker)
        }
      }
      group.addEventListener('tap', function (evt) {
        map.setCenter(evt.target.getPosition())
        openBubble(
          evt.target.getPosition(), evt.target.instruction)
      }, false)
      // Add the maneuvers group to the map
      map.addObject(group)
    }
  }
}
</script>
